import { render } from "./Supporters.vue?vue&type=template&id=57848097&scoped=true&bindings={}"
import script from "./Supporters.vue?vue&type=script&lang=js"
export * from "./Supporters.vue?vue&type=script&lang=js"

import "./Supporters.vue?vue&type=style&index=0&id=57848097&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-57848097"

export default script